import { render, staticRenderFns } from "./FeedbackEdit.vue?vue&type=template&id=14f81b2a"
import script from "./FeedbackEdit.vue?vue&type=script&lang=js"
export * from "./FeedbackEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports